<div class="flex gap-1.5">
	<div (click)="copyLink()" class="cursor-pointer">
		<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
			<g clip-path="url(#clip0_2429_30)">
				<path d="M16.8587 5.75366V3.11825C16.8587 2.58898 16.4297 2.15991 15.9004 2.15991H2.48372C1.95446 2.15991 1.52539 2.58897 1.52539 3.11825V16.5349C1.52539 17.0642 1.95446 17.4932 2.48372 17.4932H5.11914" stroke="#7D5A20" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
				<path d="M7.75464 9.34737C7.75464 8.81809 8.1837 8.38904 8.71297 8.38904H22.1296C22.6589 8.38904 23.088 8.8181 23.088 9.34737V22.764C23.088 23.2933 22.6589 23.7224 22.1296 23.7224H8.71297C8.18369 23.7224 7.75464 23.2933 7.75464 22.764V9.34737Z" stroke="#7D5A20" stroke-width="1.5" stroke-linejoin="round"/>
			</g>
			<defs>
				<clipPath id="clip0_2429_30">
					<rect width="24" height="24" fill="white" transform="translate(0.306641 0.941162)"/>
				</clipPath>
			</defs>
		</svg>
	</div>
	<div (click)="share()" class="cursor-pointer">
		<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M8.80469 11.5C8.80469 12.7405 7.79908 13.7461 6.55859 13.7461C5.31811 13.7461 4.3125 12.7405 4.3125 11.5C4.3125 10.2595 5.31811 9.25391 6.55859 9.25391C7.79908 9.25391 8.80469 10.2595 8.80469 11.5Z" stroke="#7D5A20"/>
			<path d="M13.2969 6.55859L8.80469 9.70312" stroke="#7D5A20" stroke-linecap="round"/>
			<path d="M13.2969 16.4414L8.80469 13.2969" stroke="#7D5A20" stroke-linecap="round"/>
			<path d="M17.7891 17.3398C17.7891 18.5803 16.7834 19.5859 15.543 19.5859C14.3025 19.5859 13.2969 18.5803 13.2969 17.3398C13.2969 16.0994 14.3025 15.0938 15.543 15.0938C16.7834 15.0938 17.7891 16.0994 17.7891 17.3398Z" stroke="#7D5A20"/>
			<path d="M17.7891 5.66016C17.7891 6.90064 16.7834 7.90625 15.543 7.90625C14.3025 7.90625 13.2969 6.90064 13.2969 5.66016C13.2969 4.41967 14.3025 3.41406 15.543 3.41406C16.7834 3.41406 17.7891 4.41967 17.7891 5.66016Z" stroke="#7D5A20"/>
		</svg>
	</div>
</div>

